import { render, staticRenderFns } from "./UIForm.vue?vue&type=template&id=5d9213fb&"
import script from "./UIForm.vue?vue&type=script&lang=js&"
export * from "./UIForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports